"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SickLeaveRequest_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Appointment_1 = require("./Appointment");
var ClinicalEventForSickLeaveRequest_1 = require("./ClinicalEventForSickLeaveRequest");
var ClinicalEvent_1 = require("./ClinicalEvent");
var User_1 = require("./User");
var Location_1 = require("./Location");
var Patient_1 = require("./Patient");
var SickLeaveRequest_Factory = /** @class */ (function () {
    function SickLeaveRequest_Factory() {
    }
    SickLeaveRequest_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Appointment: Appointment_1.Appointment_Factory.CreateIncoming(model.Appointment),
            AppointmentId: model.AppointmentId,
            ClinicalEventLinks: model.ClinicalEventLinks && model.ClinicalEventLinks.map(function (i) { return ClinicalEventForSickLeaveRequest_1.ClinicalEventForSickLeaveRequest_Factory.CreateIncoming(i); }),
            ClinicalEvents: model.ClinicalEvents && model.ClinicalEvents.map(function (i) { return ClinicalEvent_1.ClinicalEvent_Factory.CreateIncoming(i); }),
            CreatedBy: User_1.User_Factory.CreateIncoming(model.CreatedBy),
            CreatedById: model.CreatedById,
            FormattedRequestJson: model.FormattedRequestJson,
            Location: Location_1.Location_Factory.CreateIncoming(model.Location),
            LocationId: model.LocationId,
            Patient: Patient_1.Patient_Factory.CreateIncoming(model.Patient),
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RequestJson: model.RequestJson,
            ResponseCode: model.ResponseCode,
            ResponseJson: model.ResponseJson,
            SehaOrganizationId: model.SehaOrganizationId,
        };
        return result;
    };
    SickLeaveRequest_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Appointment: Appointment_1.Appointment_Factory.CreateOutgoing(model.Appointment),
            AppointmentId: model.AppointmentId,
            ClinicalEventLinks: model.ClinicalEventLinks && model.ClinicalEventLinks.map(function (i) { return ClinicalEventForSickLeaveRequest_1.ClinicalEventForSickLeaveRequest_Factory.CreateOutgoing(i); }),
            ClinicalEvents: model.ClinicalEvents && model.ClinicalEvents.map(function (i) { return ClinicalEvent_1.ClinicalEvent_Factory.CreateOutgoing(i); }),
            CreatedBy: User_1.User_Factory.CreateOutgoing(model.CreatedBy),
            CreatedById: model.CreatedById,
            FormattedRequestJson: model.FormattedRequestJson,
            Location: Location_1.Location_Factory.CreateOutgoing(model.Location),
            LocationId: model.LocationId,
            Patient: Patient_1.Patient_Factory.CreateOutgoing(model.Patient),
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RequestJson: model.RequestJson,
            ResponseCode: model.ResponseCode,
            ResponseJson: model.ResponseJson,
            SehaOrganizationId: model.SehaOrganizationId,
        };
        return result;
    };
    return SickLeaveRequest_Factory;
}());
exports.SickLeaveRequest_Factory = SickLeaveRequest_Factory;
